import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contact.scss";
import * as emailjs from "emailjs-com";
import Title from "../ui-components/title/title";
import Modal from '../contact-modal/Modal';
//import Button from '../ui-components/button/button'
import LinkedinIcon from "../../assets/contact/linkedin.svg";
import GithubIcon from "../../assets/contact/github.svg";
import BehanceIcon from "../../assets/contact/behance.svg";
import Thumb from "../../assets/contact/thumbs.png";
import Resume from "../../assets/pdf/ResumeRusyaidi.pdf";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: "",
      email: "",
      message: "",
      sending: false,
      successModal: false,
      errorModal: false,
    };
  }

  onResumeClick() {
    window.open(Resume);
    console.log("REsume  click");
  }

  inputHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (e) => {
    var self = this;
    this.setState({ sending: true });
    e.preventDefault();

    var template_params = {
      fullname: this.state.fullname,
      email: this.state.email,
      message: this.state.message,
    };




    // YOUR EMAIL.JS API KEY IN FORMAT user_xxxxxxxxxxxxxxxxxx
    let API_KEY = "user_sU86QHBTVUnWCWYQzSA7f";

    // YOUR EMAIL.JS TEMPLATE ID
    let TEMPLATE_ID = "template_442s56l";




    emailjs.send("default_service", TEMPLATE_ID, template_params, API_KEY).then(
      function (response) {
        if (response.status === 200) {
          self.showSuccessModal();
        } else {
          self.showErrorModal();
        }
      },
      function (error) {
        self.showErrorModal();
      }
    );
  };

  // SUCCESS MODAL
  showSuccessModal = () => {
    this.setState({ successModal: true, sending: false });
    this.resetForm();
  };
  // ERROR MODAL
  showErrorModal = () => {
    this.setState({ errorModal: true, sending: false });
    this.resetForm();
  };
  // RESET CONTACT FORM
  resetForm() {
    this.setState({ fullname: "", email: "", message: "" });
  }
  // CLOSE ALL MODALS
  closeModal = () => {
    this.setState({ successModal: false, errorModal: false });
  };

  resetForm = () => {
    this.setState({ fullname: "", email: "", message: "" });
  };

  render() {
    let submitButtonRender = (
      <div className="small__button">
        <button aria-label="send message" type="submit" value="Send Message">
          Send Message
        </button>
      </div>
    );
    if (this.state.sending) {
      submitButtonRender = (
        <div className="small__button sending-btn">
          <div className="flex-center">
            <div className="sbl-circ"></div>
          </div>
        </div>
      );
    }
    let modalRender = null;
    if (this.state.successModal) {
      modalRender = <Modal closeModal={this.closeModal} status="success" />;
    } else if (this.state.errorModal) {
      modalRender = <Modal closeModal={this.closeModal} status="error" />;
    }
    return (
      <div id="contact">
        {modalRender}
        <div className="wrapper">
          <div className="contact-title flex">
            <Title title="Just say hi." />
            <img src={Thumb} alt="thumb" />
          </div>

          <p className="font18">
            Do you want to say hello, or do you want to get started on your project and need my assistance? Please do not hesitate to contact me.
          </p>

          <Row className="paddingtop80">
            <Col md={12} lg={6}>
              <div className="contact-details flex">
                <h4 className="weight300">Mail me at</h4>
                <a href="mailto:rsydmz@gmail.com">
                  <p className="font20">rsydmz@gmail.com</p>
                </a>

                <h4 className="weight300">Contact me on</h4>
                <a href="http://wasap.my/60132711014">
                  <p className="font20">+6013 2711014</p>
                </a>

                <h4 className="weight300">Follow me</h4>
                <div className="contact-social-all">
                  <a href="https://www.linkedin.com/in/rusyaidii/" target="_blank" rel="noopener noreferrer">
                    <img src={LinkedinIcon} alt="linkedin" className="contact-social" />
                  </a>
                  <a href="https://www.github.com/rusyaidii" target="_blank" rel="noopener noreferrer">
                    <img src={GithubIcon} alt="github" className="contact-social" />
                  </a>
                  <a href="https://www.behance.net/rusyaidii" target="_blank" rel="noopener noreferrer">
                    <img src={BehanceIcon} alt="behance" className="contact-social" />
                  </a>
                </div>
              </div>

              {/*<a className="resume-btn" href="#" onClick={this.onResumeClick}>
                <Button label="Resume PDF" />
              </a>*/}

              <div className="small__button">
                <button onClick={this.onResumeClick} >Resume PDF</button>
              </div>

            </Col>
            <Col md={12} lg={6}>
              <form id="contact-form" onSubmit={this.handleSubmit}>
                <input className="font18 weight500" type="text" placeholder="Name" required name="fullname" value={this.state.fullname} onChange={this.inputHandler} />
                <input className="font18 weight500" type="email" placeholder="Email" required name="email" value={this.state.email} onChange={this.inputHandler} />
                <textarea
                  className="font18"
                  rows="6"
                  cols="50"
                  placeholder="Message..."
                  required
                  name="message"
                  value={this.state.message}
                  onChange={this.inputHandler}
                ></textarea>
                {submitButtonRender}
              </form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
};

export default Contact;
